import React, { Component } from 'react';
import { Form, Col, InputGroup } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter, FaGithubSquare } from 'react-icons/fa'

class Basics extends Component {


    render() {
        const [parentState, parentSetState] = this.props.state


        return (
            <Form>
                <Form.Row>
                    <Form.Group as={Col} lg={3} sm={12} xs={12} controlId="formGridEmail">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            value={parentState.name} onChange={(e) => { parentSetState({ name: e.target.value }) }}
                            type="text" required placeholder="eg. Jack Smith" />
                    </Form.Group>

                    <Form.Group as={Col} lg={3} sm={12} xs={12} controlId="formGridPassword">
                        <Form.Label>Tagline</Form.Label>
                        <Form.Control
                            value={parentState.tagline} onChange={(e) => { parentSetState({ tagline: e.target.value }) }}
                            type="text" required placeholder="eg. Web Developer" />
                    </Form.Group>
                    <Form.Group as={Col} lg={2} sm={12} xs={12} controlId="formGridPassword">
                        <Form.Label>Phone No.</Form.Label>
                        <Form.Control
                            value={parentState.phone} onChange={(e) => { parentSetState({ phone: e.target.value }) }}
                            type="text" required placeholder="eg. 1234567890" />
                    </Form.Group>
                    <Form.Group as={Col} lg={4} sm={12} xs={12} controlId="formGridPassword">
                        <Form.Label>Resume Link</Form.Label>
                        <Form.Control
                            value={parentState.resume} onChange={(e) => { parentSetState({ resume: e.target.value }) }}
                            type="text" placeholder="eg. GoogleDrive link to your Resume" />
                    </Form.Group>
                </Form.Row>

                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>About Me</Form.Label>
                    <Form.Control
                        value={parentState.about} onChange={(e) => { parentSetState({ about: e.target.value }) }}
                        as="textarea" rows="3" placeholder="eg. Hi, I'm Jack Smith, I'm a ......" />
                </Form.Group>

                {/* <Form.Row>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            value={parentState.email} onChange={(e) => { parentSetState({ email: e.target.value }) }}
                            type="email" required placeholder="eg. sinanu1998@gmail.com" />
                    </Form.Group>

                    
                </Form.Row> */}

                <Form.Row>

                    <Form.Group as={Col} lg={Col} md={6} sm={12} xs={12} controlId="formGridCity">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id="inputGroupPrepend"><FaFacebookF /></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                value={parentState.facebook} onChange={(e) => { parentSetState({ facebook: e.target.value }) }}
                                type="text"
                                placeholder="eg. Facebook Link"
                                aria-describedby="inputGroupPrepend"
                                
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group as={Col} lg={Col} md={6} sm={12} xs={12} controlId="formGridCity">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id="inputGroupPrepend"><FaInstagram /></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                value={parentState.instagram} onChange={(e) => { parentSetState({ instagram: e.target.value }) }}
                                type="text"
                                placeholder="eg. Instagram Link"
                                aria-describedby="inputGroupPrepend"
                               
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group as={Col} lg={Col} md={6} sm={12} xs={12} controlId="formGridCity">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id="inputGroupPrepend"><FaLinkedin /></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                value={parentState.linkedin} onChange={(e) => { parentSetState({ linkedin: e.target.value }) }}
                                type="text"
                                placeholder="eg. Linkedin Link"
                                aria-describedby="inputGroupPrepend"
                                
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group as={Col} lg={Col} md={6} sm={12} xs={12} controlId="formGridCity">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id="inputGroupPrepend"><FaTwitter /></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                value={parentState.twitter} onChange={(e) => { parentSetState({ twitter: e.target.value }) }}
                                type="text"
                                placeholder="eg. Twitter Link"
                                aria-describedby="inputGroupPrepend"
                                
                            />
                        </InputGroup>
                    </Form.Group>

                    <Form.Group as={Col} lg={Col} md={6} sm={12} xs={12} controlId="formGridCity">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id="inputGroupPrepend"><FaGithubSquare /></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                value={parentState.github} onChange={(e) => { parentSetState({ github: e.target.value }) }}
                                type="text"
                                placeholder="eg. GitHub Link"
                                aria-describedby="inputGroupPrepend"
                                
                            />
                        </InputGroup>
                    </Form.Group>
                </Form.Row>




            </Form>
        )
    }
}

export default Basics;